export const topicData = [
    {
        "id": -1,
        "keyword_stats": [
            "motion to adjourn",
            "easement",
            "nominations",
            "entertain a motion to adjourn",
            "duplexes",
            "minute recess",
            "whole truth",
            "will faithfully",
            "roundabouts",
            "Indigenous peoples"
        ],
        "name": "Local governance",
        "query_id": "local-governance"
    },
    {
        "id": 70,
        "keyword_stats": [
            "plan",
            "plans",
            "proposal",
            "planning",
            "Master Plan",
            "planner",
            "proposals",
            "Strategic Plan",
            "Strategic",
            "propose"
        ],
        "name": "Planning process",
        "query_id": "planning-process"
    },
    {
        "id": 64,
        "keyword_stats": [
            "music",
            "event",
            "events",
            "celebrate",
            "Celebration",
            "attended",
            "band",
            "concert",
            "birthday",
            "tour"
        ],
        "name": "Events and celebrations",
        "query_id": "events-and-celebrations"
    },
    {
        "id": 5,
        "keyword_stats": [
            "art",
            "artists",
            "artist",
            "exhibit",
            "Mural",
            "museum",
            "arts",
            "exhibits",
            "artwork",
            "murals"
        ],
        "name": "Public art",
        "query_id": "public-art"
    },
    {
        "id": 45,
        "keyword_stats": [
            "library",
            "Book",
            "books",
            "libraries",
            "librarian",
            "reading",
            "librarians",
            "children",
            "library card",
            "free"
        ],
        "name": "Public libraries",
        "query_id": "public-libraries"
    },
    {
        "id": 33,
        "keyword_stats": [
            "dog",
            "dogs",
            "animals",
            "animal",
            "pets",
            "Cat",
            "Cats",
            "pet",
            "Dog Park",
            "birds"
        ],
        "name": "Animal issues",
        "query_id": "animal-issues"
    },
    {
        "id": 31,
        "keyword_stats": [
            "food",
            "restaurant",
            "restaurants",
            "Eat",
            "lunch",
            "meals",
            "retail",
            "meal",
            "kitchen",
            "store"
        ],
        "name": "Food and dining",
        "query_id": "food-and-dining"
    },
    {
        "id": 28,
        "keyword_stats": [
            "camera",
            "cameras",
            "footage",
            "security cameras",
            "video",
            "body cameras",
            "installed",
            "security",
            "surveillance",
            "turn"
        ],
        "name": "Surveillance cameras",
        "query_id": "surveillance-cameras"
    },
    {
        "id": 57,
        "keyword_stats": [
            "bike",
            "bikes",
            "bicycle",
            "ride",
            "bicycles",
            "bike lanes",
            "biking",
            "riding",
            "bike lane",
            "cycling"
        ],
        "name": "Bicycle transportation",
        "query_id": "bicycle-transportation"
    },
    {
        "id": 83,
        "keyword_stats": [
            "housing",
            "affordable housing",
            "affordable",
            "homes",
            "houses",
            "housing crisis",
            "House",
            "home",
            "single family",
            "single family homes"
        ],
        "name": "Affordable housing",
        "query_id": "affordable-housing"
    },
    {
        "id": 9,
        "keyword_stats": [
            "license",
            "licenses",
            "licensing",
            "business license",
            "licensed",
            "driver",
            "issued",
            "Application",
            "business",
            "cup"
        ],
        "name": "Business licensing",
        "query_id": "business-licensing"
    },
    {
        "id": 49,
        "keyword_stats": [
            "bid",
            "bids",
            "contractor",
            "contractors",
            "bidding",
            "bidder",
            "biders",
            "low bid",
            "received",
            "Award"
        ],
        "name": "Bidding process",
        "query_id": "bidding-process"
    },
    {
        "id": 35,
        "keyword_stats": [
            "grass",
            "plant",
            "plants",
            "weeds",
            "mowing",
            "turf",
            "planting",
            "lawn",
            "garden",
            "seed"
        ],
        "name": "Turf and grass",
        "query_id": "turf-and-grass"
    },
    {
        "id": 39,
        "keyword_stats": [
            "maintenance",
            "equipment",
            "repair",
            "repairs",
            "replace",
            "replaced",
            "repaired",
            "replacement",
            "fix",
            "replacing"
        ],
        "name": "Equipment maintenance/replacement",
        "query_id": "equipment-maintenance-replacement"
    },
    {
        "id": 27,
        "keyword_stats": [
            "homeless",
            "homelessness",
            "shelter",
            "shelters",
            "beds",
            "experiencing homelessness",
            "homeless population",
            "bed",
            "housing",
            "emergency shelter"
        ],
        "name": "Homelessness issues",
        "query_id": "homelessness-issues"
    },
    {
        "id": 107,
        "keyword_stats": [
            "floor",
            "building",
            "Construction",
            "buildings",
            "architect",
            "floor is yours",
            "wall",
            "built",
            "brick",
            "build"
        ],
        "name": "Building construction",
        "query_id": "building-construction"
    },
    {
        "id": 29,
        "keyword_stats": [
            "parking",
            "parking spaces",
            "parking lots",
            "Park",
            "parked",
            "parking spots",
            "spaces",
            "space",
            "cars",
            "spot"
        ],
        "name": "Parking issues",
        "query_id": "parking-issues"
    },
    {
        "id": 69,
        "keyword_stats": [
            "project",
            "projects",
            "development",
            "developer",
            "developers",
            "completed",
            "develop",
            "move forward",
            "excited",
            "moving forward"
        ],
        "name": "Development projects",
        "query_id": "development-projects"
    },
    {
        "id": 37,
        "keyword_stats": [
            "grant",
            "grants",
            "apply",
            "awarded",
            "applied",
            "funding",
            "Application",
            "received",
            "Federal",
            "funds"
        ],
        "name": "Grant funding",
        "query_id": "grant-funding"
    },
    {
        "id": 60,
        "keyword_stats": [
            "traffic",
            "roads",
            "intersection",
            "Road",
            "streets",
            "Lane",
            "speed",
            "lanes",
            "crosswalk",
            "speed limit"
        ],
        "name": "Traffic management",
        "query_id": "traffic-management"
    },
    {
        "id": 47,
        "keyword_stats": [
            "Lights",
            "light",
            "Lighting",
            "street lights",
            "dark",
            "lit",
            "red light",
            "night",
            "Bright",
            "led"
        ],
        "name": "Street lighting",
        "query_id": "street-lighting"
    },
    {
        "id": 74,
        "keyword_stats": [
            "tax",
            "taxes",
            "property taxes",
            "sales tax",
            "property",
            "tax rate",
            "tax revenue",
            "pay",
            "increase",
            "paying"
        ],
        "name": "Local taxation",
        "query_id": "local-taxation"
    },
    {
        "id": 78,
        "keyword_stats": [
            "acres",
            "land",
            "acre",
            "land use",
            "acreage",
            "units per acre",
            "per acre",
            "lands",
            "approximately",
            "size"
        ],
        "name": "Land use",
        "query_id": "land-use"
    },
    {
        "id": 79,
        "keyword_stats": [
            "audit",
            "Finance",
            "audits",
            "Financial",
            "accounting",
            "auditor",
            "finance committee",
            "auditors",
            "financial statements",
            "auditing"
        ],
        "name": "Financial audit",
        "query_id": "financial-audit"
    },
    {
        "id": 82,
        "keyword_stats": [
            "property",
            "properties",
            "property owner",
            "property owners",
            "owner",
            "owned",
            "sell",
            "owners",
            "owns",
            "private"
        ],
        "name": "Property ownership",
        "query_id": "property-ownership"
    },
    {
        "id": 20,
        "keyword_stats": [
            "hospital",
            "medical",
            "Doctor",
            "Health",
            "patients",
            "hospitals",
            "treatment",
            "doctors",
            "cancer",
            "health care"
        ],
        "name": "Healthcare issues",
        "query_id": "healthcare-issues"
    },
    {
        "id": 105,
        "keyword_stats": [
            "feet",
            "height",
            "foot",
            "setback",
            "elevation",
            "elevations",
            "tall",
            "distance",
            "maximum height",
            "setbacks"
        ],
        "name": "Building setbacks",
        "query_id": "building-setbacks"
    },
    {
        "id": 46,
        "keyword_stats": [
            "attorney",
            "court",
            "legal",
            "law",
            "lawyer",
            "appeal",
            "attorneys",
            "case",
            "Courts",
            "cases"
        ],
        "name": "Legal matters",
        "query_id": "legal-matters"
    },
    {
        "id": 66,
        "keyword_stats": [
            "Police",
            "officers",
            "Police Department",
            "police officers",
            "Officer",
            "law enforcement",
            "police officer",
            "policing",
            "Police Chief",
            "patrol"
        ],
        "name": "Police matters",
        "query_id": "police-matters"
    },
    {
        "id": 65,
        "keyword_stats": [
            "crime",
            "gun",
            "crimes",
            "guns",
            "gun violence",
            "shooting",
            "firearms",
            "shootings",
            "shot",
            "homicides"
        ],
        "name": "Gun violence",
        "query_id": "gun-violence"
    },
    {
        "id": 52,
        "keyword_stats": [
            "kids",
            "children",
            "parents",
            "youth",
            "child",
            "daycare",
            "child care",
            "Young",
            "kid",
            "parent"
        ],
        "name": "Children, youth, childcare",
        "query_id": "children-youth-childcare"
    },
    {
        "id": 30,
        "keyword_stats": [
            "parks",
            "Park",
            "playground",
            "playgrounds",
            "recreation",
            "playground equipment",
            "Parks and Recreation",
            "amenities",
            "Parks and Rec",
            "Master Plan"
        ],
        "name": "Parks and Recreation",
        "query_id": "parks-and-recreation"
    },
    {
        "id": 24,
        "keyword_stats": [
            "sports",
            "Basketball",
            "baseball",
            "Soccer",
            "sport",
            "Field",
            "pickleball",
            "play",
            "Coach",
            "teams"
        ],
        "name": "Sports facilities",
        "query_id": "sports-facilities"
    },
    {
        "id": 14,
        "keyword_stats": [
            "alcohol",
            "liquor license",
            "liquor",
            "beer",
            "drink",
            "wine",
            "license",
            "liquor licenses",
            "drinking",
            "liquor store"
        ],
        "name": "Alcohol licensing",
        "query_id": "alcohol-licensing"
    },
    {
        "id": 121,
        "keyword_stats": [
            "million",
            "000",
            "thousand",
            "500",
            "2 million",
            "million dollars",
            "5 million",
            "400",
            "200",
            "300"
        ],
        "name": "Budget discussions",
        "query_id": "budget-discussions"
    },
    {
        "id": 25,
        "keyword_stats": [
            "data",
            "metrics",
            "dashboard",
            "metric",
            "collect",
            "database",
            "data collection",
            "benchmark",
            "rating",
            "collected"
        ],
        "name": "Data analysis",
        "query_id": "data-analysis"
    },
    {
        "id": 36,
        "keyword_stats": [
            "contract",
            "agreement",
            "contracts",
            "Extension",
            "agreements",
            "renewal",
            "Negotiations",
            "negotiation",
            "negotiate",
            "negotiating"
        ],
        "name": "Contract negotiations",
        "query_id": "contract-negotiations"
    },
    {
        "id": 43,
        "keyword_stats": [
            "applicant",
            "applicants",
            "Application",
            "Applications",
            "apply",
            "interview",
            "interviews",
            "position",
            "applying",
            "applied"
        ],
        "name": "Job applications",
        "query_id": "job-applications"
    },
    {
        "id": 59,
        "keyword_stats": [
            "sidewalk",
            "sidewalks",
            "driveway",
            "asphalt",
            "driveways",
            "curb",
            "pavement",
            "paved",
            "concrete",
            "streets"
        ],
        "name": "Sidewalk infrastructure",
        "query_id": "sidewalk-infrastructure"
    },
    {
        "id": 97,
        "keyword_stats": [
            "sewer",
            "pipe",
            "water and sewer",
            "Water",
            "pipes",
            "septic",
            "sanitary sewer",
            "sewers",
            "pipeline",
            "sewage"
        ],
        "name": "Sewer infrastructure",
        "query_id": "sewer-infrastructure"
    },
    {
        "id": 51,
        "keyword_stats": [
            "school",
            "schools",
            "students",
            "education",
            "High School",
            "teachers",
            "student",
            "School District",
            "teacher",
            "Class"
        ],
        "name": "Education, schools, students",
        "query_id": "education-schools-students"
    },
    {
        "id": 54,
        "keyword_stats": [
            "sign",
            "signage",
            "signs",
            "signatures",
            "signed",
            "signature",
            "signing",
            "stop sign",
            "stop signs",
            "stickers"
        ],
        "name": "Signage regulations",
        "query_id": "signage-regulations"
    },
    {
        "id": 77,
        "keyword_stats": [
            "Zoning",
            "rezoning",
            "zone",
            "zoning code",
            "rezone",
            "zoned",
            "residential",
            "zones",
            "zoning districts",
            "ordinance"
        ],
        "name": "Zoning regulations",
        "query_id": "zoning-regulations"
    },
    {
        "id": 56,
        "keyword_stats": [
            "downtown",
            "businesses",
            "downtown core",
            "Area",
            "downtowns",
            "vibrant",
            "business owners",
            "buildings",
            "vibrant downtown",
            "revitalization"
        ],
        "name": "Downtown development",
        "query_id": "downtown-development"
    },
    {
        "id": 23,
        "keyword_stats": [
            "Ambulance",
            "Emergency",
            "ambulances",
            "paramedic",
            "Paramedics",
            "ems",
            "emergencies",
            "hospital",
            "medical",
            "emergency response"
        ],
        "name": "Emergency Medical Services",
        "query_id": "emergency-medical-services"
    },
    {
        "id": 95,
        "keyword_stats": [
            "salary",
            "salaries",
            "pay",
            "reimbursement",
            "paid",
            "payment",
            "invoices",
            "reimbursed",
            "invoice",
            "wages"
        ],
        "name": "Salary and compensation",
        "query_id": "salary-and-compensation"
    },
    {
        "id": 18,
        "keyword_stats": [
            "drug",
            "drugs",
            "opioid",
            "Addiction",
            "overdose",
            "overdoses",
            "fentanyl",
            "substance abuse",
            "opioid settlement",
            "medication"
        ],
        "name": "Drugs",
        "query_id": "drugs"
    },
    {
        "id": 73,
        "keyword_stats": [
            "lease",
            "rent",
            "rental",
            "tenant",
            "tenants",
            "landlord",
            "rentals",
            "landlords",
            "renting",
            "leases"
        ],
        "name": "Tenant issues",
        "query_id": "tenant-issues"
    },
    {
        "id": 21,
        "keyword_stats": [
            "insurance",
            "liability",
            "health insurance",
            "insurance company",
            "insurance companies",
            "Liability Insurance",
            "insured",
            "coverage",
            "policy",
            "Health"
        ],
        "name": "Insurance discussions",
        "query_id": "insurance-discussions"
    },
    {
        "id": 85,
        "keyword_stats": [
            "pray",
            "Church",
            "prayer",
            "let",
            "God",
            "churches",
            "Lord",
            "pastor",
            "Thank",
            "ask"
        ],
        "name": "Religion, prayer, church",
        "query_id": "religion-prayer-church"
    },
    {
        "id": 68,
        "keyword_stats": [
            "permit",
            "permits",
            "issued",
            "permitting",
            "conditional use permit",
            "Application",
            "building",
            "special",
            "permitting process",
            "special permit"
        ],
        "name": "Permit processes",
        "query_id": "permit-processes"
    },
    {
        "id": 96,
        "keyword_stats": [
            "debt",
            "loan",
            "interest rates",
            "debt service",
            "Credit",
            "interest rate",
            "Bank",
            "loans",
            "borrow",
            "borrowing"
        ],
        "name": "Debt management",
        "query_id": "debt-management"
    },
    {
        "id": 16,
        "keyword_stats": [
            "marijuana",
            "Cannabis",
            "smoke",
            "smoking",
            "pot",
            "tobacco",
            "weed",
            "dispensaries",
            "medical marijuana",
            "cigarettes"
        ],
        "name": "Cannabis regulation",
        "query_id": "cannabis-regulation"
    },
    {
        "id": 48,
        "keyword_stats": [
            "Green",
            "color",
            "red",
            "colors",
            "blue",
            "yellow",
            "paint",
            "purple",
            "orange",
            "Gray"
        ],
        "name": "Color references",
        "query_id": "color-references"
    },
    {
        "id": 12,
        "keyword_stats": [
            "bond",
            "bonds",
            "bonding",
            "issued",
            "million",
            "issue",
            "bonded",
            "debt",
            "General Obligation",
            "Bond rating"
        ],
        "name": "Municipal bonds",
        "query_id": "municipal-bonds"
    },
    {
        "id": 34,
        "keyword_stats": [
            "trees",
            "tree",
            "planted",
            "planting",
            "plant",
            "tree canopy",
            "cut",
            "canopy",
            "removed",
            "forest"
        ],
        "name": "Tree management",
        "query_id": "tree-management"
    },
    {
        "id": 89,
        "keyword_stats": [
            "trash",
            "recycling",
            "garbage",
            "waste",
            "landfill",
            "recycle",
            "bags",
            "dumpster",
            "solid waste",
            "dump"
        ],
        "name": "Waste management",
        "query_id": "waste-management"
    },
    {
        "id": 15,
        "keyword_stats": [
            "pool",
            "pools",
            "swim",
            "swimming",
            "swimming pool",
            "swim lessons",
            "swimming pools",
            "slide",
            "slides",
            "swimming lessons"
        ],
        "name": "Swimming pools",
        "query_id": "swimming-pools"
    },
    {
        "id": 3,
        "keyword_stats": [
            "fence",
            "fencing",
            "fences",
            "fenced",
            "chain link fence",
            "foot fence",
            "foot",
            "privacy fence",
            "line",
            "height"
        ],
        "name": "Fencing issues",
        "query_id": "fencing-issues"
    },
    {
        "id": 50,
        "keyword_stats": [
            "Training",
            "certification",
            "certified",
            "trained",
            "certificate",
            "trainings",
            "train",
            "certifications",
            "Certificates",
            "applause"
        ],
        "name": "Training and certification",
        "query_id": "training-and-certification"
    },
    {
        "id": 2,
        "keyword_stats": [
            "airport",
            "pilot",
            "pilot program",
            "plane",
            "fly",
            "flight",
            "pilots",
            "airports",
            "flying",
            "planes"
        ],
        "name": "Airport operations",
        "query_id": "airport-operations"
    },
    {
        "id": 17,
        "keyword_stats": [
            "Safety",
            "safe",
            "risk",
            "security",
            "dangerous",
            "safer",
            "risks",
            "Cyber security",
            "protection",
            "danger"
        ],
        "name": "Safety and security",
        "query_id": "safety-and-security"
    },
    {
        "id": 7,
        "keyword_stats": [
            "language",
            "languages",
            "translation",
            "bilingual",
            "translate",
            "English",
            "Spanish",
            "interpreter",
            "different languages",
            "translated"
        ],
        "name": "Language matters",
        "query_id": "language-matters"
    },
    {
        "id": 40,
        "keyword_stats": [
            "nonprofit",
            "nonprofits",
            "donations",
            "fundraising",
            "donation",
            "sponsor",
            "donate",
            "fundraiser",
            "501c3",
            "sponsors"
        ],
        "name": "Non-profit fundraising",
        "query_id": "non-profit-fundraising"
    },
    {
        "id": 22,
        "keyword_stats": [
            "fire department",
            "firefighters",
            "fire station",
            "fires",
            "Firefighter",
            "Fire Chief",
            "fireworks",
            "departments",
            "fire stations",
            "Police"
        ],
        "name": "Fire department",
        "query_id": "fire-department"
    },
    {
        "id": 58,
        "keyword_stats": [
            "trucks",
            "truck",
            "vehicles",
            "cars",
            "vehicle",
            "Car",
            "trailer",
            "trailers",
            "drivers",
            "fleet"
        ],
        "name": "Vehicles and transportation",
        "query_id": "vehicles-and-transportation"
    },
    {
        "id": 110,
        "keyword_stats": [
            "Water",
            "gallons",
            "water supply",
            "drinking water",
            "million gallons",
            "water quality",
            "water treatment",
            "gallon",
            "groundwater",
            "main"
        ],
        "name": "Water management",
        "query_id": "water-management"
    },
    {
        "id": 8,
        "keyword_stats": [
            "black",
            "race",
            "diversity",
            "white",
            "color",
            "racism",
            "racist",
            "women",
            "discrimination",
            "diverse"
        ],
        "name": "Racial issues",
        "query_id": "racial-issues"
    },
    {
        "id": 55,
        "keyword_stats": [
            "bus",
            "buses",
            "transit",
            "Transportation",
            "bus stop",
            "bus stops",
            "bus drivers",
            "bus routes",
            "ride",
            "service"
        ],
        "name": "Public transit",
        "query_id": "public-transit"
    },
    {
        "id": 109,
        "keyword_stats": [
            "storm water",
            "storm",
            "drainage",
            "rain",
            "flooding",
            "flood",
            "storms",
            "storm water management",
            "drain",
            "Water"
        ],
        "name": "Stormwater management",
        "query_id": "stormwater-management"
    },
    {
        "id": 91,
        "keyword_stats": [
            "snow",
            "Environmental",
            "winter",
            "Climate",
            "gas",
            "cold",
            "sustainability",
            "climate change",
            "weather",
            "environment"
        ],
        "name": "Climate sustainability",
        "query_id": "climate-sustainability"
    },
    {
        "id": 90,
        "keyword_stats": [
            "solar",
            "electric",
            "energy",
            "electricity",
            "charge",
            "charging",
            "solar panels",
            "electric vehicles",
            "battery",
            "batteries"
        ],
        "name": "Renewable energy",
        "query_id": "renewable-energy"
    },
    {
        "id": 94,
        "keyword_stats": [
            "boat",
            "sand",
            "Beach",
            "boats",
            "Beaches",
            "numbers",
            "kayak",
            "shoreline",
            "ocean",
            "kayaks"
        ],
        "name": "Boating and beaches",
        "query_id": "boating-and-beaches"
    },
    {
        "id": 106,
        "keyword_stats": [
            "roof",
            "roofs",
            "stairs",
            "roofing",
            "deck",
            "stair",
            "siding",
            "rooftop",
            "flat roof",
            "roof replacement"
        ],
        "name": "Roof, stairs, siding",
        "query_id": "roof-stairs-siding"
    },
    {
        "id": 0,
        "keyword_stats": [
            "annexation",
            "annexed",
            "Annex",
            "annexations",
            "annexing",
            "acres",
            "Annexation agreement",
            "petition",
            "property",
            "land"
        ],
        "name": "Annexation process",
        "query_id": "annexation-process"
    }
];
export const issueKeywords = [
    "homelessness",
    "affordable housing",
    "public safety",
    "redistricting",
    "transparency",
    "climate change",
    "gun violence",
    "transportation",
    "sustainability",
    "mental health",
    "marijuana",
    "rent control",
    "diversity",
    "bargaining",
    "short term rentals",
    "conflict of interest",
    "negotiations",
    "education",
    "environmental justice",
    "contention",
    "development",
    "leaf blowers",
    "storm water",
    "infrastructure",
    "law enforcement",
    "sidewalks",
    "discrimination",
    "reparations",
    "workforce housing",
    "inclusion",
    "human trafficking",
    "racial equity",
    "water quality",
    "redevelopment",
    "code enforcement",
    "term limits",
    "fireworks",
    "health care",
    "environment",
    "litigation",
    "spot zoning",
    "short term rental",
    "food insecurity",
    "stormwater",
    "historic preservation",
    "annexation",
    "gun control",
    "election integrity",
    "ranked choice voting",
    "equity and inclusion",
    "housing affordability",
    "aesthetics",
    "multi family",
    "water conservation",
    "insurance",
    "recreation",
    "local control",
    "recycling",
    "public engagement",
    "hybrid meetings",
    "pickleball",
    "heritage trees",
    "climate action",
    "landscaping",
    "partisanship",
    "special use permits",
    "censorship",
    "traffic congestion",
    "plastic bags",
    "preservation",
    "engagement",
    "representation",
    "accountability",
    "septic systems",
    "inflation",
    "accessibility",
    "human rights",
    "fire safety",
    "preemption",
    "drop boxes",
    "land use",
    "cash flow",
    "addiction",
    "virtual meetings",
    "regulation",
    "hazard pay",
    "vaccination",
    "corruption",
    "impact fees",
    "nuisance animals",
    "special assessments",
    "child abuse",
    "panhandling",
    "equal opportunity",
    "cross contamination",
    "tenant protections",
    "stormwater management",
    "pedestrian safety",
    "broadband access",
    "bicycle and pedestrian safety",
    "overcrowding",
    "hazardous waste",
    "sea level rise",
    "mitigation"
];
export const numCities = 655;
export const featuredTopics = [
    {
        "date": "2024-02-09_2",
        "query_id": "black-history-month",
        "title": "black history month"
    },
    {
        "date": "2024-02-26",
        "query_id": "opioid-settlements",
        "title": "opioid settlements"
    },
    {
        "date": "2024-03-11",
        "query_id": "sidewalks",
        "title": "sidewalks"
    },
    {
        "date": "2024-03-25_2",
        "query_id": "absenteeism",
        "title": "absenteeism"
    },
    {
        "date": "all",
        "query_id": "all",
        "title": "all"
    },
    {
        "date": "yiu_on_test",
        "query_id": "chronic-absenteeism-districtview",
        "title": "chronic absenteeism districtview"
    },
    {
        "date": "2024-04-08",
        "query_id": "bus-rapid-transit",
        "title": "bus rapid transit"
    },
    {
        "date": "nsba",
        "query_id": "nsba",
        "title": "nsba"
    },
    {
        "date": "rezoning_test",
        "query_id": "rezoning",
        "title": "rezoning"
    },
    {
        "date": "2024-04-22",
        "query_id": "harm-reduction",
        "title": "harm reduction"
    },
    {
        "date": "2024-05-06",
        "query_id": "pickleball",
        "title": "pickleball"
    },
    {
        "date": "2024-05-20",
        "query_id": "canada",
        "title": "canada"
    },
    {
        "date": "2024-06-03",
        "query_id": "cycling",
        "title": "cycling"
    },
    {
        "date": "2024-06-17",
        "query_id": "climate-change",
        "title": "climate change"
    },
    {
        "date": "2024-07-15",
        "query_id": "immigration",
        "title": "immigration"
    },
    {
        "date": "ic2s2",
        "query_id": "fentanyl-test-strips",
        "title": "fentanyl test strips"
    },
    {
        "date": "2024-07-29",
        "query_id": "short-term-rentals",
        "title": "short-term-rentals"
    },
    {
        "date": "2024-08-12",
        "query_id": "homelessness",
        "title": "homelessness"
    },
    {
        "date": "2024-08-26",
        "query_id": "accessory-dwelling-units",
        "title": "accessory dwelling units"
    },
    {
        "date": "2024-09-09",
        "query_id": "rent-control",
        "title": "rent control"
    },
    {
        "date": "2024-09-23",
        "query_id": "participatory-budgeting",
        "title": "participatory budgeting"
    },
    {
        "date": "2024-09-22",
        "query_id": "participatory-budget",
        "title": "participatory budget"
    },
    {
        "date": "2024-10-07",
        "query_id": "ranked-choice-voting",
        "title": "ranked choice voting"
    },
    {
        "date": "2024-10-17",
        "query_id": "homelessness",
        "title": "homelessness"
    },
    {
        "date": "2024-10-21",
        "query_id": "voter-turnout",
        "title": "voter turnout"
    },
    {
        "date": "research",
        "query_id": "research",
        "title": "research"
    },
    {
        "date": "2025-01-13",
        "query_id": "fluoride",
        "title": "fluoride"
    },
    {
        "date": "2025-02-05",
        "query_id": "black-history-month-2025",
        "title": "black history month 2025"
    },
    {
        "date": "2025-02-10",
        "query_id": "civicsearch-website-v2",
        "title": "civicsearch-website-v2"
    },
    {
        "date": "2025-03-07",
        "query_id": "2025-03-07",
        "title": "2025-03-07"
    },
    {
        "date": "2025-03-14",
        "query_id": "2025-03-14",
        "title": "2025-03-14"
    },
    {
        "date": "2025-03-15",
        "query_id": "egg-prices",
        "title": "egg prices"
    },
    {
        "date": "2025-03-21",
        "query_id": "2025-03-21",
        "title": "2025-03-21"
    },
    {
        "date": "2025-03-28",
        "query_id": "2025-03-28",
        "title": "2025-03-28"
    },
    {
        "date": "2025-04-04",
        "query_id": "2025-04-04",
        "title": "2025-04-04"
    },
    {
        "date": "2025-04-05",
        "query_id": "tariffs",
        "title": "tariffs"
    },
    {
        "date": "2025-04-11",
        "query_id": "2025-04-11",
        "title": "2025-04-11"
    },
    {
        "date": "2025-04-18",
        "query_id": "2025-04-18",
        "title": "2025-04-18"
    },
    {
        "date": "2025-04-25",
        "query_id": "2025-04-25",
        "title": "2025-04-25"
    }
];